import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  FormDataConsumer,
  required,
  Identifier,
  RaRecord,
} from "react-admin";
import { parse } from "query-string";
import { useLocation } from "react-router";

import EmailInput from "../common/EmailInput";
import { helpNotes } from "./MailForwardCreate";
import { validateFromEmailAddress, validateToEmailAddress } from "./validators";
import useUpdateWithValidation from "../common/useUpdateWithValidation";
import FormContainer from "../common/FormContainer";

const MailForwardEdit = () => {
  const location = useLocation();
  const { returnTo } = parse(location.search);

  const fromDomain = (
    _resource?: string,
    _id?: Identifier,
    data?: Partial<RaRecord>,
    _state?: object
  ) => `Domain/${data?.domainId}/show/mail-forwards`;

  const save = useUpdateWithValidation("MailForward", {
    redirectTo: returnTo === "MailForwardFromDomains" ? fromDomain : "list",
  });

  return (
    <Edit>
      <SimpleForm onSubmit={save}>
        <FormContainer>
          <ReferenceInput
            source="customerId"
            reference="Customer"
            sort={{ field: "name", order: "ASC" }}
            filterToQuery={(searchText: any) => ({
              q: searchText,
            })}
          >
            <AutocompleteInput
              optionText="name"
              fullWidth
              validate={required()}
            />
          </ReferenceInput>

          <FormDataConsumer>
            {({ formData, ...rest }) => (
              <ReferenceInput
                source="domainId"
                reference="Domain"
                sort={{ field: "unicodeName", order: "ASC" }}
                filter={{ customerId: formData.customerId }}
                filterToQuery={(searchText: any) => ({
                  q: searchText,
                })}
                {...rest}
              >
                <AutocompleteInput
                  optionText="unicodeName"
                  fullWidth
                  validate={required()}
                />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <EmailInput
            source="fromEmailAddress"
            validate={validateFromEmailAddress}
            allowEmptyLocalPart
            fullWidth
          />
          <TextInput
            multiline
            source="toEmailAddress"
            validate={validateToEmailAddress}
            fullWidth
          />
        </FormContainer>
        <FormContainer maxWidth="lg">
          <TextInput multiline source="description" fullWidth />
          {helpNotes}
        </FormContainer>
      </SimpleForm>
    </Edit>
  );
};

export default MailForwardEdit;
